"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarWeekPickerViewStyles = void 0;
const createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
exports.calendarWeekPickerViewStyles = createStyles_1.default((_theme) => ({
    wrapper: {
        display: 'inline',
    },
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NhbGVuZGFyL2RhdGUtcGlja2VyL3BpY2tlcnMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQVFBLDRFQUFvRDtBQUV2QyxRQUFBLDRCQUE0QixHQUFHLHNCQUFZLENBQUMsQ0FBQyxNQUFhLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDM0UsT0FBTyxFQUFFO1FBQ1AsT0FBTyxFQUFFLFFBQVE7S0FDbEI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9